import Vue from 'vue';
import endpoints from "./endpoints";

export default {
	install(app, options){
			const self = this;

			
			Vue.prototype.$api = {
				apiBaseUrl: endpoints.base_url
			}

			Vue.prototype.$apiEndpoints = {
				login: function(){
					return endpoints.base_url + endpoints.auth.login;
				},
				refresh: function(){
					return endpoints.base_url + endpoints.auth.refresh;
				},
				userList: function(){
					return endpoints.base_url + endpoints.users.index;
				},
				userCreate: function(){
					return endpoints.base_url + endpoints.users.create;
				},
				userDelete: function(user_id){
					return endpoints.base_url + endpoints.users.delete.replace(/:user_id/g, user_id);
				},
				userMoneyboxAssignmentCreate: function(user_id){
					return endpoints.base_url + endpoints.users.moneybox_assignment.create.replace(/:user_id/g, user_id);
				},
				userSegmentAssignmentCreate: function(user_id){
					return endpoints.base_url + endpoints.users.segment_assignment.create.replace(/:user_id/g, user_id);
				},
				moneyboxList: function(){
					return endpoints.base_url + endpoints.moneyboxes.index;
				},
				moneyboxCreate: function(){
					return endpoints.base_url + endpoints.moneyboxes.create;
				},
				moneyboxDelete: function(moneybox_id){
					return endpoints.base_url + endpoints.moneyboxes.delete.replace(/:moneybox_id/g, moneybox_id);
				},
				moneyboxUnloadIntervalCreate: function(moneybox_id){
					return endpoints.base_url + endpoints.moneyboxes.unload_interval.create.replace(/:moneybox_id/g, moneybox_id);
				},				
				user: function(){
					return endpoints.base_url + endpoints.user.show;
				},
				userSegmentInfo: function(){
					return endpoints.base_url + endpoints.user.segment_info;
				},
				userMoneyboxUnloads: function(){
					return endpoints.base_url + endpoints.user.moneybox_unloads;
				},
				corporationList: function(){
					return endpoints.base_url + endpoints.corporations.index;
				},
				corporationCreate: function(){
					return endpoints.base_url + endpoints.corporations.create;
				},
				corporationDelete: function(corporation_id){
					return endpoints.base_url + endpoints.corporations.delete.replace(/:corporation_id/g, corporation_id);
				},
				corporationMoneyboxAssignmentCreate: function(corporation_id){
					return endpoints.base_url + endpoints.corporations.moneybox_assignment.create.replace(/:corporation_id/g, corporation_id);
				},
				reportsBasic: function(){
					return endpoints.base_url + endpoints.reports.basic;
				},
				reportsMoneyboxUnloadState: function(){
					return endpoints.base_url + endpoints.reports.moneybox_unload_state;
				},
				segmentIndex: function(){
					return endpoints.base_url + endpoints.segments.index;
				},
				segmentTypeIndex: function(){
					return endpoints.base_url + endpoints.segments.types.index;
				},
				segmentCreate: function(){
					return endpoints.base_url + endpoints.segments.create;
				},
			}
		}
};